export class AttendanceReport {
    Class;
    sec;
    totalStudents;
    studentsPresent;
    studentsAbsent;
    attendancePercent;
    numberOfDays;
    totalSessions;
    detailedReport;
    monthlyReports;

    constructor(data) {
        this.Class = data.Class;
        this.sec = data.sec;
        this.totalStudents = data.totalStudents;
        this.studentsPresent = data.studentsPresent;
        this.studentsAbsent = data.studentsAbsent;
        this.attendancePercent = data.attendancePercent;
        this.numberOfDays = data.numberOfDays;
        this.totalSessions = data.totalSessions;
        this.detailedReport = data.detailedReport || {};
        this.monthlyReports = data.monthlyReports || [];
    }

    static fromJson(json) {
        return new AttendanceReport(json);
    }
}
